import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import HandoverTimeline from "components/handover-timeline/handover-timeline";
import { Handover } from "graphql/generated/graphql";
import { useLoggedUser } from "state/reactive-vars/logged-user-var";
import { formatDate } from "utils/helpers";
import routeNames from "constants/route-names";
import { HandoverStatus } from "constants/field-values";

interface HandoversListItemProps {
	handover: Handover;
	isForReview?: boolean;
}

const HandoversListItem = ({ handover, isForReview = false }: HandoversListItemProps) => {
	const navigate = useNavigate();
	const { loggedUserValue } = useLoggedUser();
	const { project_name, vendor_organization, property, status, updated_at, vendor_organization_id } = handover;

	// Customer sees vendor name; vendor sees property name as subtitle
	const isVendor = loggedUserValue.organization_id === vendor_organization_id;
	const subtitle = isVendor ? property?.name : vendor_organization?.name;

	const isCompleted = status === HandoverStatus.PUBLISHED || status === HandoverStatus.CANCELLED;

	const handleOnClick = useCallback(() => {
		navigate(routeNames.HANDOVER_DETAILS.replace(":handoverId", handover.id));
	}, [handover.id]);

	if (isCompleted) {
		return (
			<div className="hli-completed-card" onClick={handleOnClick}>
				<div className="hli-project-details">
					<div>{project_name}</div>
					<div>{subtitle}</div>
				</div>
				<div>
					<img src={`${process.env.PUBLIC_URL}/assets/images/icons/step-completed-circle.svg`} alt="Published" />
					<div className="ht-timeline-description">
						<div>{status === HandoverStatus.CANCELLED ? "Cancelled" : "Published"}</div>
						<div>{formatDate(updated_at)}</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={isForReview ? "hli-review-card" : "hli-card"} onClick={handleOnClick}>
			<HandoverTimeline handover={handover} />
			<div className="hli-project-details">
				<div>{project_name}</div>
				<div>{subtitle}</div>
			</div>
		</div>
	);
};

export default HandoversListItem;
